
import { Container, Image, Row, Col, CardDeck, Card } from 'react-bootstrap';

import hostPapaImg from '../../img/news/Blog20210227_NewSite/HostPapaLogo.png';

import React from 'react';
import { INewsItemData } from './NewsData';



//Short description for use in lists.
export let Blog20210227_NewSite_Short: INewsItemData =
{
    isPublished: true
    , publishDate: new Date('2021-02-27')
    , title: "Website updated"
    , shortDescription: "It’s been a long time coming but I finally overhauled my website..."
    , path: "/news/Blog20210227_NewSite"
    , component: Blog20210227_NewSite
}

//Full Article
function Blog20210227_NewSite() {
    return <Container className="page-container p-3">
        <Row><Col className="news-data-title"><h2>{Blog20210227_NewSite_Short.title}</h2></Col></Row>
        <Row><Col className="news-data-published-date">{Blog20210227_NewSite_Short.publishDate.toISOString().slice(0, 10)}</Col></Row>
        <Row className="pt-5"><Col className="news-data-content">
            <p>It’s been a long time coming but I finally overhauled my website. After 5 years on my free wordpress
            blog, I bought 3 years of web hosting. After buying the hosting, I realized I probably should have had my website ready (whoops!).
    I checked their web builder but for my pricing tier level I could only create 2 pages and pay to create more so I decided to just code my own.</p>

            <p>About a year ago, I had my first introduction to <a target="_blank" href="https://reactjs.org/">React</a>. I used it to build <a target="_blank" href="https://docs.microsoft.com/en-us/powerapps/developer/component-framework/overview">custom PCFs for Dynamics CRM</a> for work. I really liked the component-based JavaScript library and
    I figured this website would give me a good reason to use it again.</p>

            <p>Cheers to the next 3 years!</p>
        </Col></Row>
    </Container >
}

export default Blog20210227_NewSite;
